import React, { FC } from 'react';
import styles from './pageWrapper.module.scss';

const PageWrapper: FC<{ className?: string; children: React.ReactNode}> = (props) => (
    <div className={`${styles.pageWrapper} ${props.className ?? ''}`}>
        {props.children}
    </div>
)
export default PageWrapper;
